<template>
  <b-badge
    :style="badgeStyle"
    class="master-status-badge"
    data-testid="master-status-badge"
  >
    {{ label }}
  </b-badge>
</template>

<script>
import {
  MASTER_STATUS_BADGE,
  MASTER_STATUS_LABEL,
} from "@/constants/costGl";

export default {
  name: "MasterStatusBadge",
  props: {
    status: {
      type: String,
      default: null,
    },
  },
  computed: {
    label() {
      return MASTER_STATUS_LABEL[this.status] || "ไม่พบสถานะ";
    },
    badgeStyle() {
      return MASTER_STATUS_BADGE[this.status] || MASTER_STATUS_BADGE.CANCELLED;
    },
  },
};
</script>

<style scoped>
.master-status-badge {
  font-size: 14px;
  font-weight: 400;
  padding: 0.35em 0.65em;
  border-radius: 20px;
}
</style>
